import type { TableData, TablePaginationType, TableProps } from './Table';

const DEFAULT_ROWS_PER_PAGE = 5;

type UseClientDataProps<Data extends TableData> = Omit<TableProps<Data>, 'pagination'> & {
  rowsPerPage?: number;
  paginationType?: TablePaginationType;
};

export const useClientTable = <Data extends TableData>({
  rowsPerPage = DEFAULT_ROWS_PER_PAGE,
  paginationType = 'button',
  ...rest
}: UseClientDataProps<Data>): TableProps<Data> => {
  return {
    pagination: {
      hasNextPage: false,
      rowsPerPage,
      isFetching: false,
      type: paginationType,
    },
    ...rest,
  };
};
